import { ProgressProps, Root, Indicator } from "@radix-ui/react-progress"

export const ProgressBar = (props: ProgressProps) => {
	const { max, value } = props
	const percentageComplete = max && value ? (value / max) * 100 : 0

	return (
		<Root className="h-1 overflow-hidden rounded bg-base-700" {...props}>
			<Indicator
				className="h-full rounded-full bg-base-400"
				style={{ transform: `translateX(-${100 - percentageComplete}%)` }}
			/>
		</Root>
	)
}
